import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Button } from '@mui/material'
import React, { useState } from 'react'
import CloseButton from '../../common/components/CloseButton'
import { useRenameCustomModuleMutation } from '../../api/trainingTopics'
import useMutation from '../../hooks/useMutation'

export default function RenameModuleModal({ handleClose, open, rowData = null }) {
  const [moduleName, setModuleName] = useState(rowData?.module || '')
  const isDisabled = !moduleName.trim()

  const { submit, isLoading } = useMutation(useRenameCustomModuleMutation, {
    successMessage: 'Module successfully renamed',
    onSuccess: () => {
      handleClose()
      setModuleName('')
    }
  })

  function handleSubmit() {
    const payload = { name: moduleName }
    submit({ topicId: rowData.trainingId, moduleId: rowData?.trainingModuleId, ...payload })
  }

  const handleCancel = () => {
    handleClose()
    setModuleName('')
  }

  return (
    <Dialog open={open} onClose={handleCancel} sx={styles.dialog}>
      <DialogTitle sx={styles.title}>
        <Typography sx={styles.titleText}>{'Edit Module'}</Typography>
        <div style={styles.closeButton}>
          <CloseButton onClick={handleCancel} />
        </div>
      </DialogTitle>
      <DialogContent sx={styles.content}>
        <TextField
          autoFocus
          label='Module name'
          fullWidth
          value={moduleName}
          onChange={e => setModuleName(e.target.value)}
          sx={styles.textField}
        />
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button
          onClick={handleSubmit}
          disabled={isDisabled || isLoading}
          variant='contained'
          fullWidth
          sx={styles.button}
        >
          {isLoading ? 'Loading...' : 'Rename'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
const styles = {
  dialog: {
    '& .MuiPaper-root': {
      borderRadius: '16px',
      maxWidth: 'unset',
      width: '570px'
    }
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '8px'
  },
  titleText: {
    color: '#1B1B26',
    fontFamily: 'Satoshi',
    fontWeight: 900,
    fontSize: 35,
    textAlign: 'center'
  },
  closeButton: {
    position: 'absolute',
    right: '16px',
    top: '16px'
  },
  content: {
    p: 3,
    width: '570px'
  },
  textField: {
    mt: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '14px'
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Plus Jakarta Sans',
      fontWeight: 400,
      fontSize: '16px'
    }
  },
  actions: {
    p: 3,
    justifyContent: 'center'
  },
  button: {
    height: '60px',
    borderRadius: '14px',
    backgroundColor: '#6123FF',
    color: '#fff',
    textTransform: 'none',
    fontFamily: 'Plus Jakarta Sans',
    width: '100%',
    '&:hover': {
      backgroundColor: '#7843ff'
    }
  }
}
